<template>
	<div>
		<div class="border-bottom text-muted mb-2 mx-3" ><b>
				<b-icon icon="search" aria-hidden="true"></b-icon>
				借款还款信息查询
			</b></div>
		<div class="d-flex justify-content-center pt-2">
			<div style="width: 80%;">
				<b-form-group description="" class="mb-0">
					<b-form-input placeholder="输入姓名" type="search" v-model="userName" ref="input" autocomplete="off"
						onselect="return false">
					</b-form-input>
				</b-form-group>
				<b-form-group description="" class="mb-0 mt-2">
					<b-form-input id="input-valid" placeholder="输入证件号码" type="search" v-model="userIdNo">
					</b-form-input>
				</b-form-group>
			</div>
		</div>
		
		<div class="d-flex justify-content-center mt-3" v-if="hasCards>0">
			<a href="#" style="text-decoration: underline;"  @click="mycardlist">你目前绑定{{hasCards}}张银行卡</a>
		</div>	
		<div class="d-flex justify-content-center mt-3">
			
			<b-button variant="success" @click="getLoanList" class="">查询待还合同</b-button>
			<b-button variant="success" @click="getRepayList" class="ml-2">查询已还合同</b-button>
<!-- 			<b-button squared variant="secondary" class="ml-3" @click="setOpenIdtest"> setOpenid</b-button> -->
		</div>

		<b-overlay :show="show" rounded="sm" style="font-size: 90%;">
			<div v-if="repayingIndex>=0&&totalCount>0" class="mt-3 mx-4 "><a href="#" @click="showRepaying"
					style="text-decoration:underline;">您有<span class="text-primary">
						1</span>笔还款正在处理中...</a>
			</div>

			<div v-if="totalCount==0" class="d-flex flex-column align-items-center mt-5 text-muted  "
				>
				<div class="mt-2"><img src="../assets/nodata.svg" width="20px" height="20px">您的借款已全部结清</div>
			</div>
			
			<div v-if="repayCount==0" class="d-flex flex-column align-items-center mt-5 text-muted  ">
				<div class="mt-2"><img src="../assets/nodata.svg" width="20px" height="20px">未查询到您的还款销账信息</div>
			</div>

			<div v-if="!isError">
				<div v-if="totalCount>0" class="mt-3 mx-4">您有<span class="text-primary">
						{{totalCount}}</span>笔待还合同，总待还金额<span class="text-primary">{{totalAmt/100}}</span>元。
					<span class="text-danger" v-if="repayingIndex==-1"><b>您已逾期{{overdueDays}}天，请尽快还款!</b></span>
				</div>
			</div>

			<div v-if="isError" class="mt-5 mx-4 d-flex justify-content-center">
				<span class="text-danger">
					<b-icon icon="exclamation-circle" aria-hidden="true"></b-icon>
					<b>{{errMsg}}</b>
				</span>
			</div>

			<div v-if="LoanList!=null">
				<div v-for="(item, index) in LoanList" :key="index" class="  m-2 rounded border"
					:class="{'bg-light':index%2==0}">
					<div class=" mx-2">
						<div class="border-bottom p-1">
							借款产品：{{item.productName}}
						</div>
						<div class="border-bottom p-1 text-nowrap">
							合同编号：<span style="font-size: 90%;">{{item.loanContractNo}}</span>
						</div>
						<div class="border-bottom p-1">
							借款时间：{{item.loanDate.substring(0,10)}}
						</div>
					</div>
					<div class="d-flex justify-content-between mx-3 mt-3 border-bottom">
						<div class="font-weight-bold">
							期数
						</div>
						<div class="font-weight-bold">
							应还日期
						</div>
						<div class="font-weight-bold">
							应还金额
						</div>
					</div>
					<div class="d-flex justify-content-between mx-3 p-2 border-bottom">
						<div>
							{{item.period}}
						</div>
						<div>
							{{item.currBillDate}}
						</div>
						<div>
							{{item.repayAmount/100}}
						</div>
					</div>
				</div>
				<div class=" d-flex justify-content-end mr-5 mt-1 mb-1" v-if="isRepay">
					<b-button variant="success" class="" @click="showRepay(LoanList)">还款</b-button>
				</div>
			</div>
			
			

			<div v-if="RepayList!=null">
				<div v-for="(item, index) in RepayList" :key="index" class="  m-2 rounded"
					:class="{'bg-light':index%2==0}">
					<div class=" mx-3" v-if="(item.repayStatus==5||item.repayStatus==1||item.repayStatus=='SUCCESS')
								&&(item.repayMode!='MGTCANCEL'&&item.repayMode!='MITIGATE')">
						<div class="border-bottom p-1">
							合同编号：{{item.loanContractNo}}
						</div>
						<div class="border-bottom p-1">
							还款金额：{{item.repayAmount/100}}元
						</div>
						<div class="border-bottom p-1">
							还款时间：{{item.repayDate}}
						</div>
						<div class=" p-1">
							<span v-if="item.repayStatus==5">还款结果： 还款成功</span>
							<span v-if="item.repayStatus==9">还款结果： 还款失败</span>
							<span v-if="item.repayStatus==1"> 还款结果：还款处理中</span>
							<span v-if="item.repayStatus=='SUCCESS'"> 还款结果：还款成功</span>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
		<div class="   mt-3">
			<div class="text-danger mx-3 mt-2 text-center" style="font-size:12px;" v-if="(totalCount>0||totalCount==-1)&&repayCount==-1">
				还款支付完成后，同银行系统核实您的还款需要时间，请您耐心等待。核实款项到账后会及时为您更新，谢谢！
			</div>
			<div class="d-flex justify-content-center border-top mx-3 mt-2" style="font-size:12px;">
				<div>
					
					<div class="">
						客服热线
					</div>
					<div class="" >
						消费贷：021-31156909(服务时间：09:00-18:00)
					</div>
					<div class="   " >
						生活贷：4001505888(服务时间：09:00-18:00)
					</div>
				</div>
			</div>
		</div>
		<FtRepayModal ref="ftRepayModal"></FtRepayModal>
		<SxyRepayModal ref="sxyRepayModal"></SxyRepayModal>
		<YcRepayModal ref="ycRepayModal"></YcRepayModal>
		<RepayingModal ref="repayingModal"></RepayingModal>
		<RepayTipModal ref="repayTipModal"></RepayTipModal>
		<CardListModal ref="cardModal"></CardListModal>
		
	</div>

</template>
<script>
	import RepayTipModal from './RepayTipModal.vue';
	import SxyRepayModal from './SxyRepayModal.vue';
	import YcRepayModal from './YcRepayModal.vue';
	import FtRepayModal from './FtRepayModal.vue';
	import RepayingModal from './RepayingModal.vue';
	import CardListModal from './CardListModal.vue';
	export default {
		components: {
			SxyRepayModal,
			FtRepayModal,
			YcRepayModal,
			RepayingModal,
			RepayTipModal,
			CardListModal,
		},
		data() {
			return {
				form: {
					cardNo: '',
					userName: '',
					userIdNo: "",
					userIdNoMask: "",
					linkId: "",
				},
				LoanList: null,
				SumLoanList:[],
				RepayList: null,
				totalAmt: 0,
				totalCount: -1,
				repayCount: -1,
				show: false,
				userIdNo: "",
				userName: "",
				isError: false,
				isRepay: false,
				crfUid: "",
				errMsg: "",
				repayingList: null,
				repayingIndex: -1,
				channelNo: "",
				reductAmt: 0,
				billDateList:[],
				overdueDays:0,
				fundSource:"",
				cardList: [],
				hasCards:0,
			};
		},
		mounted() {
			console.log(this.getOpenId())
		},
		methods: {
			
			mycardlist() {
				this.$refs['cardModal'].showModal(this.cardList, this.setcard,"sxy")
			},
			
			setcard(_index) {
				console.log(_index)
				this.bindList()
			},
			
			
			showRepayTip(){
				this.$refs['repayTipModal'].showModal()
			},
			
			setOpenIdtest() {
				let that = this;
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/portal/openIdAuthMock?code=123")
					.then(function(response) {
						console.log("openId=====>", response.data)
						localStorage.setItem("_openid", response.data)
					})
					.catch(function(error) {
						console.log(error)
					});
			},
			ftPay() {
				let that = this;
				this.$axios.post("https://a.xfpay.cn/Api/ApiHandler.ashx", {
						"p0_Cmd": "TradeByCrossDomain",
						"p1_MerId": "13971360987",
						"p2_Amount": 56.08,
						"p3_plat": 38,
						"hmac": "21E9E45E1CC6F591CD2A7837F756D5E8"
					}, {
						headers: {
							'content-type': 'application/x-www-form-urlencoded',
						}
					})
					.then(function(response) {
						console.log(response)
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
					});
			},

			showRepay() {
				const now = new Date();
				const currentHour = now.getHours();
				// 检查当前时间是否晚上23点到次日凌晨6点之间
				if (currentHour >= 23 || currentHour < 6) {
					this.$bvModal.msgBoxOk('请在上午6点至晚上11点之间进行还款，谢谢！', {
							title: '提示',
							size: 'md',
							buttonSize: 'md',
							okVariant: 'success',
							okTitle: '确定',
							centered: true
						})
						.then(value => {
							console.log(value)
						})
						.catch(err => {
							// An error occurred
							console.log(err)
						})
					return false
				}

				if (this.channelNo == "YC") {
					this.$refs['ycRepayModal'].showModal(this.userIdNo, this.userName, this.crfUid, this.totalAmt, this
						.SumLoanList, this.reductAmt)
				} else if (this.channelNo == "FT"||this.channelNo == "SXY_WD") {
					//this.$refs['ftRepayModal'].showModal(this.userIdNo, this.userName, this.crfUid, this.totalAmt, this
					//	.SumLoanList, this.reductAmt,this.fundSource,this.channelNo,this.showEasyPay)
					this.showEasyPay()
				} else if(this.channelNo == "FT_FWD"){
					//this.$refs['ftRepayModal'].showModal(this.userIdNo, this.userName, this.crfUid, this.totalAmt, this
					//.SumLoanList, this.reductAmt,this.fundSource,this.channelNo,null)
					this.showRepayTip()
				}
			},
			
			showEasyPay() {
				this.$refs['sxyRepayModal'].showModal(this.userIdNo, this.userName, this.crfUid, this.totalAmt, this
					.SumLoanList, this.reductAmt,this.fundSource,this.channelNo)
			},
			
			showRepaying() {
				this.$refs['repayingModal'].showModal(this.repayingList[this.repayingIndex])
			},

			toast(toaster, append = false) {
				this.counter++
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},

			getOpenId() {
				let url = window.location.href;
				let para = url.split('?')[1];
				let plist = new URLSearchParams(para);
				let _openId = plist.get("openId")
				let _time = plist.get("time")
				console.log("_openId=====>", _openId)
				console.log("_time=====>", _time)
				localStorage.setItem("_openid", _openId)
			},

			checkInput() {
				if (this.userName.trim() == "") {
					this.toast("姓名不能为空")
					return false
				}

				if (this.userIdNo.trim() == "") {
					this.toast("证件号码不能为空")
					return false
				}
				if (this.userIdNo.length != 15 && this.userIdNo.length != 18) {
					this.toast("非法的证件号码")
					return false
				}
				return true
			},
			
			bindList() {
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.$axios.get(that.$DOMAIN() + "/wechatApi/payease/queryCardListById/" + this.userIdNo, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log(response.data.data)
						that.hasCards = response.data.data.length
						if (that.hasCards > 0) {
							that.cardList = response.data.data;
						}
						console.log("len===>",that.hasCards)
					})
					.catch(function(error) {
						console.log(error)
				});
			},
			
			
			getRepayList() {

				if (!this.checkInput())
					return;

				let _openid = localStorage.getItem("_openid")
				this.isError = false;
				this.totalCount = -1;
				this.repayCount = -1;
				this.show = true;
				this.LoanList = null;
				this.RepayList = null;
				this.isRepay = false;

				let that = this;
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/wxpaid-contract?name=" + this.userName +
						"&idno=" + this.userIdNo, {
							headers: {
								'openId': _openid
							}
						})
					.then(function(response) {
						that.show = false
						let t = response.data;
						that.repayCount=0;
						that.RepayList = t.loanContractInfoList;
						for (var j = 0; j < that.RepayList.length; j++) {
							if((that.RepayList[j].repayStatus=='SUCCESS'||
								that.RepayList[j].repayStatus==5||
								that.RepayList[j].repayStatus==1)&&(
								that.RepayList[j].repayMode!='MGTCANCEL'&&
								that.RepayList[j].repayMode!='MITIGATE')){
									that.repayCount=that.repayCount+1
								}
						}
						console.log("RepayList=====>", that.repayCount)
					})
					.catch(function(error) {
						that.show = false
						that.isError = true;
						console.log(error)
					});
			},
			
			
			
			checkRepaying() {
				let that = this;
				let _openid = localStorage.getItem("_openid")
				that.repayingIndex = -1;
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/payInfo/" + this.userIdNo, {
						headers: {
							'openId': _openid
						}
					})
					.then(function(response) {
						let t = response.data;
						//console.log("t========>", t.payInfoList)
						that.repayingList = t.payInfoList;
						for (var i = 0; i < t.payInfoList.length; i++) {
							console.log(t.payInfoList[i].status)
							if (t.payInfoList[i].status == 1) {
								that.repayingIndex = i;
								break;
							}
						}
						//console.log("repayingIndex====>", that.repayingIndex)
					})
					.catch(function(error) {
						console.log(error)
					});
			},

			getLoanList() {
				if (!this.checkInput())
					return false;
				this.checkRepaying()
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.RepayList = null;
				this.LoanList = null;
				this.totalCount = -1;
				
				this.repayCount = -1;
				this.repay = -1;
				this.isError = false;
				this.show = true;
				this.bindList()
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/unpaid-contract?name=" + this.userName +
						"&idno=" + this.userIdNo, {
							headers: {
								'openId': _openid
							}
						})
					.then(function(response) {
						that.show = false
						//console.log(response)
						let rr = response.data;
						that.totalAmt = rr.repayTotalAmount
						that.totalCount = rr.repayTotalItem
						
						let tList = rr.loanContractInfoList;
						let result=[];
						that.billDateList=[];
						//console.log("rr=======>", rr)
						//console.log("tList=======>", tList) 
						//还款显示时，把分期合同进行合并处理
						{
							for (let i = 0; i < tList.length; i++) {
								let found = false;
								let tNo=tList[i].loanContractNo;
								that.billDateList.push(tList[i].currBillDate)
								
								for (let t = 0; t < result.length; t++) {
									if (result[t].loanContractNo === tNo) {
										found=true;
										break
									}
								}
								if(!found)
								{
									let tSum=0;
									for (let j = 0; j < tList.length; j++) {
										if (tList[j].loanContractNo === tNo) {
											tSum=tSum+tList[j].repayAmount*1
										}
									}
									let t=tList[i]
									t.totalRepyaAmount=tSum;
									result.push(t);
								}
							}
						}
						that.LoanList = tList;
						that.SumLoanList=result;
						const sortedDateStrings = that.billDateList.sort((a, b) => new Date(a) - new Date(b));
						const minDateString = sortedDateStrings[0]; // 最小的日期字符串
						const startDate = new Date(minDateString);
						const endDate = new Date();
						const millisecondsDiff = endDate - startDate;
						const daysDiff = millisecondsDiff / (1000 * 60 * 60 * 24);
						that.overdueDays=Math.floor(daysDiff);	
					
						let extendItem = that.LoanList[0].extendItem;
						let jt = JSON.parse(extendItem);
						if (that.LoanList[0].productNo === 'LIFE0001') {
							that.crfUid = jt.crfUid;
						} else {
							that.crfUid = jt.crf_uid;
						}

						that.channelNo = rr.channelNo;
						that.reductAmt = rr.reductAmt;
						that.fundSource= rr.fundSource;
						if (rr.channelNo == "FT" || rr.channelNo == "YC"||rr.channelNo == "FT_FWD") {
							that.isRepay = true;
						} else {
							that.isRepay = false;
						}
						//console.log("channelNo======>", rr.channelNo)
						//console.log("billDateList===>",daysDiff)
						
					})
					.catch(function(error) {
						that.show = false
						console.log("error=====>", error.response.data.errmsg)
						that.errMsg = error.response.data.errmsg
						that.isError = true;
						console.log(error)
					});
			},
		},
	};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
